<template>
  <component
    :is="link ? 'a' : 'u'"
    data-test-basket-icon-link
    class="basket-icon-link"
    :href="link || ''"
    @click="$emit('click')"
  >
    <span class="icon" :class="iconClass" />
    <span
      v-if="text"
      data-test-basket-icon-link-text
      class="basket-icon-link__text"
      v-html="text"
    />
  </component>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BasketIconLink',
  props: {
    iconClass: {
      type: String,
      default: () => ''
    },
    text: {
      type: String,
      default: () => ''
    },
    link: {
      type: String,
      default: () => ''
    }
  }
});
</script>
<style lang="scss" scoped>
@import 'src/styles/all';
.basket-icon-link {
  display: block;
  color: $disturber-color;
  text-decoration: none;
  cursor: pointer;

  > .icon {
    color: $primary-color;
    margin-right: rem-calc(4);
  }

  > .basket-icon-link__text {
    text-decoration-line: underline;
    text-decoration-thickness: 1px;
  }
}
</style>
